import {
  NodeArticle,
  NodeBasicPage,
  NodeEvent,
  NodeHomePage,
  NodeLandingPage,
  NodeOverviewPage,
  NodePartner,
  NodeProject,
  NodeVacancy,
} from '../implementations';

const mappers = {
  article: NodeArticle,
  basic_page: NodeBasicPage,
  event: NodeEvent,
  homepage: NodeHomePage,
  landing_page: NodeLandingPage,
  overview_page: NodeOverviewPage,
  partner: NodePartner,
  project: NodeProject,
  vacancy: NodeVacancy,
};

export default mappers;
